module.exports = __webpack_public_path__ + "img/fig10.ba4e8833.jpg";